import { defineStore } from 'pinia'

export const useUserStore = defineStore('user', {
  state: () => ({
    laravel_session: ''
  }),
  actions: {
    setToken(token: string) {
      this.laravel_session = token
    },
    loginOut() {
      this.laravel_session = ''
    }
  }
})
